import { prepareJsonString } from './prepareJsonString';
import { parse } from '@prantlf/jsonlint';

const PARSE_MODE = 'json5';

export function smartJSONParse(str) {
    try {
        return parse(str, {
            mode: PARSE_MODE
        });
    } catch (e) {
        console.log('Alan Studio Info: JSON parse error:', e?.message);
    }
}

export function isValidJSON(str, skipJsonPreparation) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {

        if (skipJsonPreparation !== true) {
            str = prepareJsonString(str);
        }

        try {
            const parsedObj = parse(str, {
                mode: PARSE_MODE
            });
            return true;
        } catch (e) {
            console.log('Alan Studio Info: JSON is not valid:', e?.message);
        }
    }
    return false;
}

export function getInvalidJSONMessage(prefix, str, skipJsonPreparation) {
    if (str === false || str === true || str === null || str === 'false' || str === 'true' || str === 'null' || str === '') {
        return '';
    }
    if (skipJsonPreparation !== true) {
        str = prepareJsonString(str);
    }

    try {
        const parsedObj = parse(str, {
            mode: PARSE_MODE
        });
        if (typeof parsedObj === 'object' && parsedObj !== null) {
            return '';
        }
    } catch (e) {
        return `${prefix ? `${prefix}: ` : ''}${e?.message}`;
    }
    return '';
}
